import * as React from 'react';
import useCurrentUser from '../../../hooks/useCurrentUser';

import UserInfo from '../components/UserInfo';
import useUser from '../hooks/useUser';
import UserRoleSelectContainer from './UserRoleSelectContainer';

interface UserInfoContainerProps {
  userId: string;
  showAddSubscription?: boolean;
}

const UserInfoContainer: React.FC<UserInfoContainerProps> = ({ userId, showAddSubscription }) => {
  const { user, isLoading } = useUser(userId);
  const { isPartOfOrganization } = useCurrentUser();
  return (
    <UserInfo
      user={user}
      loading={isLoading}
      license={user?.license}
      showAddSubscription={showAddSubscription}
      roleSelect={
        !isPartOfOrganization && user?.memberships.length === 1 ? (
          <UserRoleSelectContainer membership={user.memberships[0]} />
        ) : null
      }
    />
  );
};
export default UserInfoContainer;
